import { z } from 'zod'

/**
 * 발신자 문구 프리셋 API 계약 (BIZ-43 · 기획서 6.6 · 설계 5.1).
 *
 * 기업 관리자가 회사 공식 발신자를 등록하고(등록·수정), 담당자는 주문서에서 고른다(선택).
 * 주문 생성은 이미 `senderPresetId`를 받아 sender_name을 스냅샷한다(order 계약).
 * DB `sender_preset`: sender_name 1~30자, 기업당 기본값 하나(부분 유니크).
 */

export const senderPresetResponse = z.object({
  id: z.number().int(),
  /** 리본·카드에 찍히는 발신자 문구 한 줄: '(주)0000 대표이사 홍길동' */
  senderName: z.string(),
  isDefault: z.boolean(),
  displayOrder: z.number().int(),
})
export type SenderPresetResponse = z.infer<typeof senderPresetResponse>

export const senderPresetListResponse = z.object({
  items: z.array(senderPresetResponse),
})
export type SenderPresetListResponse = z.infer<typeof senderPresetListResponse>

const senderName = z
  .string()
  .trim()
  .min(1, '발신자를 입력하세요')
  .max(30, '발신자는 30자 이하여야 합니다')

export const createSenderPresetRequest = z.object({
  senderName,
  isDefault: z.boolean().optional().default(false),
  displayOrder: z.number().int().optional(),
})
export type CreateSenderPresetRequest = z.infer<typeof createSenderPresetRequest>

/** 부분 수정. 준 필드만 바꾼다. */
export const updateSenderPresetRequest = z
  .object({
    senderName,
    isDefault: z.boolean(),
    displayOrder: z.number().int(),
  })
  .partial()
export type UpdateSenderPresetRequest = z.infer<typeof updateSenderPresetRequest>

export const SenderPresetErrorCode = {
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  NOT_FOUND: 'SENDER_PRESET_NOT_FOUND',
  NO_COMPANY: 'NO_COMPANY', // 기업 소속이 아닌 계정(운영자 등)
  FORBIDDEN: 'FORBIDDEN',
} as const
export type SenderPresetErrorCode = (typeof SenderPresetErrorCode)[keyof typeof SenderPresetErrorCode]
